import React, { Component } from 'react'
import ModalSearch from './ModalSearch'

class Modal extends Component {
  componentWillReceiveProps (props) {
    if (this.props === props) return
    if (props.isOpen && props.onOpen && !this.props.isOpen) props.onOpen()
    window.addEventListener('keydown', e => e.keyCode === 27 && this.props.isOpen && this.props.close())
  }
  render () {
    return (
      <div className='modal fade in' style={{ display: (this.props.isOpen ? 'block' : 'none') }}>
        <div className='modal-backdrop'>
          <div className={'modal-dialog ' + (this.props.big && ' big-modal-dialog')} onClick={e => e.stopPropagation()}>
            <div className={'modal-content ' + (this.props.noOverflow && 'no-overflow ')}>
              <div className='modal-header'>
                <button type='button' className='close' onClick={(e) => this.props.close.call()}><span>&times;</span></button>
                <h4 className='modal-title'>{this.props.icon && <i className={'fa fa-fw ' + this.props.icon} />} {this.props.title}</h4>
                <ModalSearch filter={this.props.filter} />
              </div>
              <div style={(this.props.height ? {'height': this.props.height} : {})} className={'modal-body ' + (this.props.big && 'big-modal-body ') + this.props.className}>
                {this.props.children}
              </div>
              <div className={(this.props.nofooter ? 'hidden' : 'modal-footer')}>
                {this.props.buttons && this.props.buttons.map((button, index) => {
                  if (button.hidden) return null
                  return (
                    <a disabled={button.disabled} key={'Modal_Button_' + index} onClick={!button.disabled && button.event} className='btn btn-primary pull-right ml-10'>{(button.icon ? <i className={'fa fa-fw ' + button.icon} /> : '')} {button.text}</a>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default Modal



// WEBPACK FOOTER //
// ./src/components/basic/containers/Modal.js